import { render, staticRenderFns } from "./identificacao.vue?vue&type=template&id=2e958a71"
import script from "./identificacao.vue?vue&type=script&lang=js"
export * from "./identificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports